type Props = {
	message?: string;
	dump?: unknown;
	httpCode?: number;
};

class CustomError extends Error {
	public readonly errorDump: unknown;
	public readonly httpCode?: number;

	constructor(props: Props) {
		super(props.message);
		this.errorDump = props.dump;
		this.httpCode = props.httpCode;

		const pr = new.target.prototype;
		if (Object.setPrototypeOf) {
			Object.setPrototypeOf(this, pr);
		} else {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this as any).__proto__ = pr;
		}
	}
}

export default CustomError;
